import { DateSelectionService } from '@softapps/core';
import { inject, linkedSignal } from '@angular/core';
import { DateService, IsoDate } from '@softline/core';

export class DashboardDateSelectionService extends DateSelectionService{
    dateService = inject(DateService);
    date = linkedSignal(() => this.dateService.now());
    constructor() {
      super();
    }

  override setDate(date: IsoDate) {
    this.date.set(date);
  }
}
